export default __webpack_public_path__ + "static/media/reduxjs.c0d97478.svg";